import * as ActionTypes from '../constants/ActionTypes';
import ExternalCalendarsAPI from '../api/ExternalCalendars';

export const createExternalCalendar = externalCalendarCreateCommand => dispatch => {
    ExternalCalendarsAPI.create(externalCalendarCreateCommand)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.ADD_EXTERNAL_CALENDAR,
                payload: data
            });
        });
};

export const deleteExternalCalendar = calendarId => dispatch => {
    return ExternalCalendarsAPI.delete(calendarId)
        .then(() => {
            dispatch({
                type: ActionTypes.DELETE_EXTERNAL_CALENDAR,
                payload: calendarId
            });
        });
};



// WEBPACK FOOTER //
// ./src/actions/ExternalCalendars.js